module.exports = __webpack_public_path__ + "static/media/pool.22a2fe51.jpg";